import fileUtils from '../../util/fileUtils';
import { handleRequestErrors } from "../../services/handleRequestError";

export const fetchCustomFields = (params = {}) => {
  const encodedParams = new URLSearchParams(params).toString();
  const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields?${encodedParams}`;

  return (dispatch) => {
    dispatch({ type: "GET_RETAILER_CUSTOM_FIELDS_REQUEST_START" });
    fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
        'RETAILER-KEY': ENV.UNIQUE_KEY,
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "GET_RETAILER_CUSTOM_FIELDS", data });
          dispatch({ type: "GET_RETAILER_CUSTOM_FIELDS_REQUEST_END" });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: "GET_RETAILER_CUSTOM_FIELDS_REQUEST_END" });
        }
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
        dispatch({ type: "GET_CUSTOM_FIELDS_REQUEST_END" });
      });
  };
};

export const createCustomField = (body) => {
  const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields`;
  const formData = fileUtils.objectToFormData({ custom_field: body });
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      headers: {
        'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
        'RETAILER-KEY': ENV.UNIQUE_KEY,
        'Accept': 'application/json, text/plain, */*'
      },
      body: formData
    })
      .then(handleRequestErrors)
      .then(
        (data) => dispatch({ type: 'CREATE_RETAILER_CUSTOM_FIELD', payload: { retailerCustomField: data.custom_field } }),
        (err) => {
          dispatch({ type: 'LOAD_DATA_FAILURE', err });
          dispatch({ type: 'TOGGLE_SUBMITTED', submitted: false });
        }
      ).catch(() => {
        dispatch({ type: 'TOGGLE_SUBMITTED', submitted: false });
      });
  };
};

export const updateCustomField = (customFieldId, body) => {
  const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields/${customFieldId}`;
  const formData = fileUtils.objectToFormData({ custom_field: body });
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      headers: {
        'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
        'RETAILER-KEY': ENV.UNIQUE_KEY,
        'Accept': 'application/json, text/plain, */*'
      },
      body: formData
    })
      .then(handleRequestErrors)
      .then(
        (data) => dispatch({ type: "UPDATE_RETAILER_CUSTOM_FIELD", payload: data.custom_field }),
        (err) => {
          dispatch({ type: 'LOAD_DATA_FAILURE', err });
          dispatch({ type: 'TOGGLE_SUBMITTED', submitted: false });
        }
      ).catch((err) => {
        dispatch({ type: "LOAD_DATA_FAILURE", err });
        dispatch({ type: 'TOGGLE_SUBMITTED', submitted: false });
      });
  };
};

export const deleteCustomField = (customFieldId) => {
  const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields/${customFieldId}`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
        'RETAILER-KEY': ENV.UNIQUE_KEY,
        "X-Access-Level": "read-write"
      }
    })
      .then(handleRequestErrors(res))
      .then((data) => {
        dispatch({ type: "DELETE_RETAILER_CUSTOM_FIELD", payload: data.custom_field });
      })
      .catch((err) => {
        dispatch({ type: "LOAD_DATA_FAILURE", err });
        handleRequestErrors(err)
      });
  };
};

export const fetchSelectCustomFields = (params = {}) => {
  const encodedParams = new URLSearchParams(params).toString();
  const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/select_custom_fields?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
        'RETAILER-KEY': ENV.UNIQUE_KEY,
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "SELECT_RETAILER_CUSTOM_FIELDS", payload: data.custom_fields });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
        }
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};
